import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export interface DashboardFilters {
  page: number;
  limit: number;
  search: string | null;
  poc_ids: FilterValue[];
  start_date: Dayjs;
  end_date: Dayjs;
  date: Dayjs;
  sortBy: string;
  sortType: SortType;
}

export interface DashboardSelectedFilters {
  page: number;
  limit: number;
  search: string | null;
  poc_ids: FilterValue[];
  start_date: string;
  end_date: string;
  date: string;
  sortBy: string;
  sortType: SortType;
}

export interface DashboardAPIFilters {
  poc_ids: FilterValue[] | null;
  start_date: string;
  end_date: string;
  date: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: "ASC" | "DESC";
  search?: string;
}

export function parseQueryParamsForDashboardFilters(
  params: DashboardFilters | null,
  query_params: URLSearchParams
): DashboardFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    page: params?.page ?? 1,
    limit: params?.limit ?? 30,
    search: params?.search ?? "",
    poc_ids: params?.poc_ids ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    date: query_params.get("date")
      ? dayjs(query_params.get("date"), "YYYY-MM-DD")
      : currentDate,
    sortBy: params?.sortBy || "created_date",
    sortType: params?.sortType ?? SortType.DESC,
  };
}
